export class E015Attributes {
  public providerName!: string;

  public stationId!: string;

  public locationAddressType!: string;

  public locationAddress!: string;

  public locationZipCode!: string;

  public locationCity!: string;

  public locationProvince!: string;

  public locationRegion!: string;

  public stationAccessibility!: AccessibilityTypes | string;

  public isAlwaysAvailable = true;

  public isFromSustainableEnergy = false;

  constructor() {


  }

}

export enum AccessibilityTypes {
  Private = "Privato",
  Public = "Pubblico",
  PrivateWithPublicAccess = "Privato con accesso pubblico"
}
